export default __webpack_public_path__ + "static/media/dspmap.266a1523.png";